import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Api, Session } from '../../services/index';
import { Router, ActivatedRoute } from '@angular/router';

declare function redirectToPhs(isTest: boolean): any;


@Component({
  selector: 'memdnavbar',
  templateUrl: './memd-navbar.component.html',
  styleUrls: ['./memd-navbar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MemdNavbarComponent implements OnInit {

  isUserAuthenticated: boolean;

  constructor(public sesssion: Session,
    private route: ActivatedRoute,
    private router: Router) { 
    this.isUserAuthenticated = this.sesssion.isAuthenticated;
  }

  ngOnInit() {
    this.isUserAuthenticated = this.sesssion.isAuthenticated;
  }
  logout(){
    this.sesssion.setAuthenticated(false);
    redirectToPhs(false);
  }
}
